import { ApplicationState } from 'application/redux';
import { close as closeModal, open as openModal } from 'core/modal/redux/actions';
import { changefieldOrder, goToFirstPage, orderItems } from 'core/pagination-optimized/redux/actions';
import { connect } from 'react-redux';
import { selectedRowIndex, selectOneRow } from './redux/actions';
import TableComponent from './table-component';

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
  t: state.i18n.t,
  spinner: state.spinner,
  hasSlider: ownProps.hasSlider,
  onSearch: ownProps.onSearch,
  search: state.search,
  table: state.table,
});

export default connect(mapStateToProps, {
  closeModal,
  openModal,
  selectedRowIndex,
  selectOneRow,
  orderItems,
  goToFirstPage,
  changefieldOrder
})(TableComponent);
